'use client';

import { useEffect, useMemo } from 'react';
import * as Sentry from '@sentry/browser';
import { CurrentUserModel } from '../models/CurrentUserModel';
import { useNextAuth } from './useNextAuth';

export const useCurrentUser = () => {
  const { isLoggedIn, session } = useNextAuth();

  const userModel = useMemo(() => new CurrentUserModel(session?.user), [session]);

  useEffect(() => {
    if (isLoggedIn) {
      Sentry.setUser({
        user_id: userModel.user_id,
        org_id: userModel.org_id,
      });
    }
  }, [isLoggedIn, userModel]);

  return {
    isLoggedIn,
    userId: userModel.user_id,
    orgId: userModel.org_id,
    sessionId: userModel.session_id,
    user: userModel,
  };
};
